import { agentHue } from '@/lib/agent-utils';
import { cn } from '@/lib/utils';

/** Avatar every new agent starts with: it says nothing, so the tile falls back to the initial. */
const DEFAULT_AVATAR = '⏺';

/**
 * Flat avatar tile for an agent: rounded square, muted fill derived from the id, optional initial.
 * (Kept under the old name so existing call sites keep working.)
 */
export function AgentOrb({
  seed,
  size = 28,
  name,
  avatar,
  className,
}: {
  seed: string;
  size?: number;
  /** Shows the first letter when the tile is big enough to read it. */
  name?: string;
  /** The agent's own icon. Shown instead of the initial unless it is the placeholder default. */
  avatar?: string | null;
  className?: string;
}) {
  const h = agentHue(seed);
  const icon = avatar && avatar !== DEFAULT_AVATAR && size >= 14 ? avatar : '';
  const initial = icon || (name && size >= 20 ? name.trim().charAt(0).toUpperCase() : '');
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center justify-center font-semibold text-white/95 select-none',
        className,
      )}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size / 4),
        fontSize: Math.round(size * (icon ? 0.56 : 0.46)),
        lineHeight: 1,
        background: `hsl(${h} 32% 38%)`,
        boxShadow: `inset 0 0 0 1px hsl(${h} 30% 55% / 0.35)`,
      }}
    >
      {initial}
    </span>
  );
}
